import Paper from '@material-ui/core/Paper';
import React from 'react';
import Draggable from 'react-draggable';

export function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable nodeRef={nodeRef} handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper ref={nodeRef} {...props} />
        </Draggable>
    );
}
